export const paymentProviderMeta: Record<string, {
  label: string;
  logo: string;
  logoClassName: string;
  secureLogo?: string;
  secureLogoClassName?: string;
}> = {
  iyzico: {
    label: "iyzico",
    logo: "/images/payment-providers/iyzico-logo.svg",
    logoClassName: "h-8 w-auto",
    secureLogo: "/images/payment-providers/iyzico-secure.png",
    secureLogoClassName: "h-10 w-auto",
  },
  param: {
    label: "Param",
    logo: "/images/payment-providers/param-logo.svg",
    logoClassName: "h-7 w-auto",
    secureLogo: "/images/payment-providers/param-secure.svg",
    secureLogoClassName: "h-10 w-auto",
  },
  esnekpos: {
    label: "EsnekPos",
    logo: "/images/payment-providers/esnekpos-logo.webp",
    logoClassName: "h-9 w-auto",
  },
  tami: {
    label: "Tami",
    logo: "/images/payment-providers/tami-logo.svg",
    logoClassName: "h-9 w-auto",
  },
};

export const getPaymentProviderMeta = (providerId: string) => (
  paymentProviderMeta[String(providerId || "").toLowerCase()] || {
    label: providerId,
    logo: "",
    logoClassName: "h-8 w-auto",
  }
);
